import "./MigArchCredit.css";

export default function MigArchCredit({ className = "" }) {
  return (
    <p className={`migarch-credit ${className}`.trim()}>
      Developed by{" "}
      <a href="https://migarch.in" target="_blank" rel="noopener noreferrer">
        MigArch
      </a>
    </p>
  );
}
